import { Grid, GridProps } from "@mui/material";

export default function FormGridContainer(props: GridProps) {
  const { children, spacing = 0.5, columnSpacing = 2, ...gridProps } = props;

  return (
    <Grid container spacing={spacing} columnSpacing={columnSpacing} {...gridProps}>
      {children}
    </Grid>
  );
}
